export default __webpack_public_path__ + "static/media/P10025.9eb111f4.png";